module.exports = __webpack_public_path__ + "static/media/bristol-go-drive.3d61ccce.png";